import Vue from 'vue';
import { store } from './store/store.js';
import App from './App.vue';
import vSelect from 'vue-select';
import {
  DatePicker,
  TimePicker,
  TimeSelect,
  Switch,
  Dialog,
  Input,
  InputNumber,
  Select,
  Form,
  FormItem,
  Option,
  Button,
  Tooltip,
  Table,
  TableColumn,
  Tag,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Checkbox,
  Loading,
  Upload,
  Progress,
} from 'element-ui';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
import Print from 'vue-print-nb';
import Toasted from 'vue-toasted';

Vue.config.productionTip = false;

import '@/assets/css/custom.css';
import 'vue-select/dist/vue-select.css';
import 'element-ui/lib/theme-chalk/index.css';

import jQuery from 'jquery';
window.jQuery = window.$ = jQuery;
import 'moment/src/moment';

import LogRocket from 'logrocket';
LogRocket.init('gw4sfv/tikker');

//set the locale of element ui
locale.use(lang);
Vue.component('v-select', vSelect);
Vue.use(DatePicker);
Vue.use(TimePicker);
Vue.use(TimeSelect);
Vue.use(Switch);
Vue.use(Toasted);
Vue.use(Dialog);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Select);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Option);
Vue.use(Button);
Vue.use(Tooltip);
Vue.use(Tag);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Dropdown);
Vue.use(Checkbox);
Vue.use(Loading);
Vue.use(Print);
Vue.use(Upload);
Vue.use(Progress);

new Vue({
  el: '#app',
  store,
  render: (h) => h(App),
});

export const EventBus = new Vue();
